module.exports = __webpack_public_path__ + "static/co-creation-model-7dc723a2d643582a2a4cc929f5e030d0.png";